var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkRepairIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0844 10.0853L5.50106 5.50198M4.5844 6.87698L6.87606 4.58531L4.12606 3.21031L3.2094 4.12698L4.5844 6.87698ZM18.3115 8.22906C18.7516 7.78935 19.0543 7.23118 19.1829 6.62249C19.3115 6.0138 19.2603 5.38086 19.0356 4.80073L17.7321 6.10423H15.8988V4.2709L17.2023 2.9674C16.6221 2.74221 15.989 2.69062 15.38 2.81891C14.7711 2.9472 14.2125 3.24984 13.7725 3.68995C13.3325 4.13006 13.03 4.68864 12.9018 5.29764C12.7737 5.90665 12.8254 6.53978 13.0507 7.1199L7.1199 13.0516C6.53978 12.8263 5.90665 12.7746 5.29764 12.9028C4.68864 13.0309 4.13006 13.3334 3.68995 13.7734C3.24984 14.2135 2.9472 14.772 2.81891 15.3809C2.69062 15.9899 2.74221 16.6231 2.9674 17.2032L4.26998 15.8997H6.10331V17.7331L4.79981 19.0366C5.37984 19.2617 6.01283 19.3134 6.62169 19.1853C7.23056 19.0571 7.78903 18.7547 8.22909 18.3149C8.66915 17.875 8.97182 17.3167 9.10022 16.7078C9.22863 16.099 9.17724 15.466 8.95231 14.8859L14.885 8.95323C15.4649 9.17752 16.0974 9.22848 16.7058 9.09992C17.3141 8.97136 17.8719 8.66881 18.3115 8.22906Z",
    stroke: "#EFB8C8",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 13.2903L15.9495 18.4273C16.0644 18.5424 16.201 18.6338 16.3513 18.6961C16.5016 18.7584 16.6627 18.7905 16.8254 18.7905C16.9881 18.7905 17.1492 18.7584 17.2995 18.6961C17.4498 18.6338 17.5863 18.5424 17.7013 18.4273L18.4273 17.7013C18.5424 17.5863 18.6338 17.4498 18.6961 17.2995C18.7584 17.1492 18.7905 16.9881 18.7905 16.8254C18.7905 16.6627 18.7584 16.5016 18.6961 16.3513C18.6338 16.201 18.5424 16.0644 18.4273 15.9495L13.2903 10.8125",
    stroke: "#EFB8C8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkRepairIcon);
export default __webpack_public_path__ + "static/media/PinkRepairIcon.1c4970b4c528c624f897d7881dfb70ce.svg";
export { ForwardRef as ReactComponent };